module.exports = __webpack_public_path__ + "54264fe0b5f840bc330f7a3f9e1d0572.jpg";